import React from 'react';
import CandleChartCard from './components/CandleChartCard';

const CandleChartLayout  = () => {
        return <CandleChartCard />
}

export default React.memo(CandleChartLayout);
